import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { LabworkRequestModel } from '../models';
import { Api, Session, Ui } from '../services/index';
import { Observable } from 'rxjs/Observable';
import { Environment } from '../app.environment';
import { MatListModule} from '@angular/material/list';
import {MatIconRegistry} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-my-documents',
  templateUrl: './my-documents.component.html',
  styleUrls: ['./my-documents.component.css']
})
export class MyDocumentsComponent implements OnInit {
labworkRequestsActive: Array<LabworkRequestModel>;
labworkRequestsProcessed: Array<LabworkRequestModel>;
labworkRequestsAll: Array<LabworkRequestModel>;
loading = false;
returnUrl: string;
public isRequesting: boolean;
panelOpenState = false;

constructor(private api: Api,
  private route: ActivatedRoute,
  private router: Router,
  private service: NotificationsService,
  private session: Session,
  private loader: Ui,
  iconRegistry: MatIconRegistry, 
  sanitizer: DomSanitizer,
public env: Environment)  { 

    this.labworkRequestsActive = new Array<LabworkRequestModel>();
    this.labworkRequestsProcessed = new Array<LabworkRequestModel>();
    this.labworkRequestsAll = new Array<LabworkRequestModel>();
    iconRegistry.addSvgIcon(
      'thumbs-up',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/examples/thumbup-icon.svg'));


  }

  ngOnInit() {
    this.loading = true;
    this.isRequesting = true;
    let _getLabworkRequestsByUserIdActive = this.api.getLabworkRequestsByUserId(this.session.patientId, 'active').map(labresults => {
     this.labworkRequestsActive = labresults;

    });

    let _getLabworkRequestsByUserIdProcessed = this.api.getLabworkRequestsByUserId(this.session.patientId, 'processed').map(labresults => {
      this.labworkRequestsProcessed = labresults;
 
     });

     let _getLabworkRequestsByUserIdAll = this.api.getLabworkRequestsByUserId(this.session.patientId, 'all').map(labresults => {
      this.labworkRequestsAll = labresults;
 
     });

     Observable.forkJoin([
       _getLabworkRequestsByUserIdActive,
       _getLabworkRequestsByUserIdProcessed,
       _getLabworkRequestsByUserIdAll
     ]).subscribe(results => {
      this.loading = false;
      this.isRequesting = false;
     }, (error) => {
      this.loading = false;
      this.isRequesting = false;
     });



  }

  viewLabRequest(labwork){
   

      //once the patient clicks the button they acknoledge that they have recieved it and will print it and submit it to CC//
      this.api.updatePatienthasLabwork(labwork.intakeId).subscribe(res => {
        let labRequestUrl = this.env.settings.bhLabworkOrderView + labwork.intakeId;
        let newWindow = window.open("about:blank", "_blank");
        newWindow.opener = null;
        newWindow.location.href = labRequestUrl;

        this.reloadMsgs();
        
         
      }, (error) => {
        let labRequestUrl = this.env.settings.bhLabworkOrderView + labwork.intakeId;
        let newWindow = window.open("about:blank", "_blank");
        newWindow.opener = null;
        newWindow.location.href = labRequestUrl;
      });
   
    

}
reloadMsgs(){
  this.loading = true;
  this.isRequesting = true;
  let _getLabworkRequestsByUserIdActive = this.api.getLabworkRequestsByUserId(this.session.patientId, 'active').map(labresults => {
   this.labworkRequestsActive = labresults;

  });

  let _getLabworkRequestsByUserIdProcessed = this.api.getLabworkRequestsByUserId(this.session.patientId, 'processed').map(labresults => {
    this.labworkRequestsProcessed = labresults;

   });

   let _getLabworkRequestsByUserIdAll = this.api.getLabworkRequestsByUserId(this.session.patientId, 'all').map(labresults => {
    this.labworkRequestsAll = labresults;

   });

   Observable.forkJoin([
     _getLabworkRequestsByUserIdActive,
     _getLabworkRequestsByUserIdProcessed,
     _getLabworkRequestsByUserIdAll
   ]).subscribe(results => {
    this.loading = false;
    this.isRequesting = false;
   }, (error) => {
    this.loading = false;
    this.isRequesting = false;
   });
}


}
